const APP_CONFIG = {
  version: "7.89.0",
  title: "Claire V7.89.0",
  version_client: "7.89.0",
};

export default APP_CONFIG;
